import { render, staticRenderFns } from "./no-damages.vue?vue&type=template&id=c2ea4ac0&scoped=true"
import script from "./no-damages.vue?vue&type=script&lang=ts"
export * from "./no-damages.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2ea4ac0",
  null
  
)

export default component.exports